import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpService } from './http/http.service';
import { Tax } from '../interface';

@Injectable({
  providedIn: 'root'
})
export class TaxService {
  constructor(private http: HttpService) { }

  public get(): Promise<Tax[]> {
    return firstValueFrom(this.http.get('/Taxes'));
  }

  public getById(id:number): Promise<Tax> {
    return firstValueFrom(this.http.get('/Taxes/'+id));
  }

  public post(data: any): Promise<Tax> {
    return firstValueFrom(this.http.post('/Taxes', data));
  }

  
  public put(id:number, data: any): Promise<Tax> {
    return firstValueFrom(this.http.put('/Taxes/',id, data));
  }

  public delete(id:number):Promise<void>{
    return firstValueFrom(this.http.delete('/Taxes/',id));
  }

}
